import { Link, useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 text-foreground-900 flex flex-col items-center justify-center text-center px-4">
      <div className="relative">
        <span className="font-heading text-[120px] md:text-[180px] leading-none font-semibold text-background-200 select-none pointer-events-none">
          404
        </span>
        <div className="relative -mt-6">
          <h1 className="font-heading text-foreground-950 text-2xl md:text-3xl">
            Página não encontrada
          </h1>
          <p className="mt-2 text-sm text-foreground-500 font-mono">
            {location.pathname}
          </p>
          <p className="mt-4 text-[15px] text-foreground-700 max-w-sm mx-auto leading-relaxed">
            O endereço que você procurou não existe ou foi movido. Que tal
            voltar para a loja e continuar explorando?
          </p>
          <Link
            to="/"
            className="mt-7 inline-flex items-center gap-2 h-11 px-6 rounded-full bg-foreground-950 hover:bg-foreground-800 text-background-50 text-[14px] font-medium transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i>
            Voltar ao início
          </Link>
        </div>
      </div>
    </div>
  );
}